import 'intl-pluralrules'
import Fetch from 'i18next-fetch-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import {config} from './config'
import i18n from 'i18next'
import {initReactI18next} from 'react-i18next'

i18n
    .use(LanguageDetector)
    .use(Fetch)
    .use(initReactI18next)
    .init({
        ...config,
        detection: {
            lookupQuerystring: 'lang',
            order: ['querystring', 'navigator'],
        },
        fallbackLng: {
            default: ['fi'],
            en: [],
        },
    })

export default i18n
